export const FEES_LOADING = 'FEES_LOADING';
export const FEES_ERROR = 'FEES_ERROR';
export const FEES_SUCCESS = 'FEES_SUCCESS';
